<template>
  <div>
    <a-layout>
      <a-layout-sider :width="210" breakpoint="md" collapsible theme="light">
        <a-spin :spinning="loadingParent">
          <a-menu mode="inline" style="min-height: 70px;" @select="seleccionarMenu">
            <a-sub-menu v-if="!$isEmpty(persona)" key="LABORAL">
              <span slot="title"><a-icon type="audit"/><span>Laboral</span></span>
              <a-menu-item v-if="!$isEmpty(persona)" key="INFORMACIONLABORAL">
                <a-icon type="audit"/>
                <span>{{$t('Contrato')}}</span>
              </a-menu-item>
              <a-menu-item v-if="!$isEmpty(persona)" key="ACTUALIZACIONLABORAL">
                <a-icon type="audit"/>
                <span>{{$t('Actualización')}}</span>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item v-if="!$isEmpty(persona)" key="DATOSPERSONALES">
              <a-icon type="idcard"/>
              <span>{{$t('Identificación')}}</span>
            </a-menu-item>
            <a-menu-item v-if="!$isEmpty(persona)" key="SALARIO">
              <a-icon type="dollar"/>
              <span>{{$t('Salario')}}</span>
            </a-menu-item>
            <a-menu-item v-if="!$isEmpty(persona)" key="BENEFICIOSFLEXIBLES">
              <a-icon type="container"/>
              <span>{{$t('Beneficios flexibles')}}</span>
            </a-menu-item>
            <a-menu-item v-if="!$isEmpty(persona)" key="SEGURIDADSOCIAL">
              <a-icon type="team"/>
              <span>{{$t('Seguridad social')}}</span>
            </a-menu-item>
            <a-menu-item v-if="!$isEmpty(persona)" key="CONTROLPAGO">
              <a-icon type="calendar"/>
              <span>{{$t('Control de pago')}}</span>
            </a-menu-item>
            <a-menu-item v-if="!$isEmpty(persona)" key="RETENCIONENFUENTE">
              <a-icon type="stop"/>
              <span>{{$t('Retención en la fuente')}}</span>
            </a-menu-item>
            <a-menu-item v-if="!$isEmpty(persona)" key="CENTRODECOSTOS">
              <a-icon type="fullscreen-exit"/>
              <span>{{$t('Centro de costos')}}</span>
            </a-menu-item>
            <a-menu-item v-if="!$isEmpty(persona)" key="BANCOS">
              <a-icon type="bank"/>
              <span>{{$t('Bancos')}}</span>
            </a-menu-item>
            <a-menu-item v-if="!$isEmpty(persona)" key="ATRIBUTOS">
              <a-icon type="snippets"/>
              <span>{{$t('Atributos')}}</span>
            </a-menu-item>
            <a-menu-item key="SANCIONES" v-if="proceso_disciplinario_hoja_vida && !$isEmpty(persona)">
              <a-icon type="snippets"/>
              <span>{{$t('Sanciones')}}</span>
            </a-menu-item>
            <a-sub-menu v-if="!$isEmpty(persona) && this.$userIsInrol('HV_BLOQUE_DOCUMENTOS')" key="DOCUMENTOS">
              <span slot="title"><a-icon type="cloud-upload"/><span>Documentos</span></span>
              <a-menu-item key="DOCUMENTOS_VINCULACION" v-if="doc_vinculacion_hoja_vida && !$isEmpty(persona) && this.$userIsInrol('HV_BLOQUE_DOC_VINCULACION')">
                <a-icon type="cloud-upload"/>
                <span>{{$t('Vinculación')}}</span>
              </a-menu-item>
              <a-menu-item key="DOCUMENTOS_DESVINCULACION" v-if="doc_desvinculacion_hoja_vida &&  !$isEmpty(persona) && this.$userIsInrol('HV_BLOQUE_DOC_DESVINCULACION')">
                <a-icon type="cloud-upload"/>
                <span>{{$t('Desvinculación')}}</span>
              </a-menu-item>
              <a-menu-item key="DOCUMENTOS_CONTRATO" v-if="doc_contrato_hoja_vida && !$isEmpty(persona) && this.$userIsInrol('HV_BLOQUE_DOC_CONTRATO')">
                <a-icon type="cloud-upload"/>
                <span>{{$t('Contrato')}}</span>
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item v-if="!$isEmpty(persona)" key="INTEGRACIONES">
              <a-icon type="deployment-unit"/>
              <span>{{$t('Integraciones')}}</span>
            </a-menu-item>
          </a-menu>
        </a-spin>
      </a-layout-sider>
      <a-layout-content>

        <a-row :gutter="[16,16]" style="margin: 3px">
          <a-col v-show="menuActivo != menu.informacionlaboral" :md="24" :xs="24">
            <a-spin :spinning="loading">
              <employee-summary :tamanoimg="tamanoimg" :persona="infoBasicEmployee" :edad="persona && persona.edad">
              </employee-summary>
            </a-spin>
          </a-col>
        </a-row>
        <a-row :gutter="[16,16]" style="margin: 3px" id="test">
          <a-col v-show="menuActivo === menu.informacionlaboral" :md="puedeCrear?12:24" :xs="24">
            <a-spin :spinning="loading">
              <employee-summary :tamanoimg="tamanoimg" :persona="infoBasicEmployee" :edad="persona && persona.edad">
              </employee-summary>
            </a-spin>
          </a-col>
          <a-col :span="24" :md="12" :xs="24" v-show="menuActivo === menu.informacionlaboral && puedeCrear">
            <a-spin :spinning="loading">
              <a-card
                v-show="menuActivo === menu.informacionlaboral">
                <a-row :gutter="[8,8]">
                  <a-col v-bind="colConfig">
                    <a-form-model-item :label="$t('Buscar persona')">
                      <form-model-lookup :placeholder="$t('Buscar persona')"
                                         style="width: 100%"
                                         endpoint="personas_hoja_vida"
                                         v-model="identificacion"
                                         :formItemConfig="{
                                          'label-col': {},
                                          'wrapper-col': {},
                                          'has-feedback': false
                                        }"
                                         @change="searchPersonChange"
                                         :selectedObj.sync="infoBasicEmployee"
                      >
                      </form-model-lookup>
                    </a-form-model-item>
                  </a-col>
                  <template v-if="rol">
                    <a-col v-bind="colSpan">
                      <biodata-crear-persona @success="personaCreada"></biodata-crear-persona>
                    </a-col>
                    <a-col v-bind="colSpan">
                      <btn-crear-contrato @success="crearContrato" v-if="identificacion" :id_person="identificacion"/>
                    </a-col>
                  </template>
                </a-row>
              </a-card>
            </a-spin>
          </a-col>

          <a-col v-if="!$isEmpty(persona)" :md="24" :xs="24">
            <a-card v-if="menuActivo !== menu.sanciones">
              <a-spin :spinning="loading">
                <a-table
                  v-bind="tbConfig"
                  rowKey="id_emp"
                  size="small"
                  :data-source="employeecv"
                  :columns="columns"
                  :row-selection="rowSelection">
                <span slot="estado" slot-scope="text">
                  <div v-if="text == 'ACTIVO'">
                  <a-badge status="success"/>ACTIVO
                </div>
                <div v-if="text == 'INACTIVO'">
                  <a-badge color="red"/>INACTIVO
                </div>
                </span>
                  <div
                    slot="filterDropdown"
                    slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px"
                  >
                    <a-input
                      v-ant-ref="c => (searchInput = c)"
                      :placeholder="`Search ${column.dataIndex}`"
                      :value="selectedKeys[0]"
                      style="width: 188px; margin-bottom: 8px; display: block;"
                      @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                      @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                    />
                    <a-button
                      type="primary"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
                      @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                    >
                      Search
                    </a-button>
                    <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                      Reset
                    </a-button>
                  </div>
                  <a-icon
                    slot="filterIcon"
                    slot-scope="filtered"
                    type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }"
                  />
                  <template slot="customRender" slot-scope="text, record, index, column">
                    <span v-if="searchText && searchedColumn === column.dataIndex">
                      <template
                        v-for="(fragment, i) in text
                          .toString()
                          .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))"
                      >
                        <mark
                          v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                          :key="i"
                          class="highlight"
                        >{{ fragment }}</mark
                        >
                        <template v-else>{{ fragment }}</template>
                      </template>
                    </span>
                    <template v-else>
                      {{ text }}
                    </template>
                  </template>
                </a-table>
              </a-spin>
            </a-card>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.actualizacionLaboral">
            <a-spin :spinning="loading">
              <employee-infolab-tabs @loadData="loadProfileData" :empleadoseleccionado="empleadoseleccionado"/>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.datosPersonales && isVisibleDatosPersonales">
            <a-spin :spinning="loading">
              <employee-datos-personales :persona="persona">

              </employee-datos-personales>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.salario && isVisibleEmployee">
            <a-spin :spinning="loading">
              <employee-salary :empleadoseleccionado="empleadoseleccionado" :tpay="tpay"></employee-salary>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.seguridadsocial && isVisibleEmployee">
            <a-spin :spinning="loading">
              <employee-social-security :empleadoseleccionado="empleadoseleccionado"
                                        :initial_date="initial_date"></employee-social-security>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.retencionenfuente && isVisibleEmployee">
            <a-spin :spinning="loading">
              <employee-retefte :empleadoseleccionado="empleadoseleccionado"></employee-retefte>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.bancos && isVisibleEmployee">
            <a-spin :spinning="loading">
              <employee-bank :empleadoseleccionado="empleadoseleccionado"></employee-bank>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.informacionlaboral && isVisibleEmployee">
            <a-spin :spinning="loading">
              <informacion-laboral :empleadoseleccionado="empleadoseleccionado"
                                   :persona="infoBasicEmployee && infoBasicEmployee.identificacion"></informacion-laboral>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.beneficiosflexibles && isVisibleEmployee">
            <a-spin :spinning="loading">
              <beneficios-flexibles :empleadoseleccionado="empleadoseleccionado"
                                    :tpay="tpay"></beneficios-flexibles>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.controlpago && isVisibleEmployee">
            <a-spin :spinning="loading">
              <payroll-control :empleadoseleccionado="empleadoseleccionado"></payroll-control>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.centrocostos && isVisibleEmployee">
            <a-spin :spinning="loading">
              <emp-centro-costo :empleadoseleccionado="empleadoseleccionado"></emp-centro-costo>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.atributos && isVisibleEmployee">
            <a-spin :spinning="loading">
              <emp-atributos :empleadoseleccionado="empleadoseleccionado"></emp-atributos>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.sanciones">
            <a-spin :spinning="loading">
              <employee-sanciones :id_person="persona.id_person"></employee-sanciones>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.docVinculacion && isVisibleEmployee">
            <a-spin :spinning="loading">
<!--              <employee-sanciones :empleadoseleccionado="empleadoseleccionado"></employee-sanciones>-->
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.docDesvinculacion && isVisibleEmployee">
            <a-spin :spinning="loading">
              <employee-cargue-doc-desvinculacion :empleadoseleccionado="empleadoseleccionado"></employee-cargue-doc-desvinculacion>
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.docContrato && isVisibleEmployee">
            <a-spin :spinning="loading">
<!--              <employee-sanciones :empleadoseleccionado="empleadoseleccionado"></employee-sanciones>-->
            </a-spin>
          </a-col>
          <a-col :span="24" v-if="menuActivo === menu.integraciones && isVisibleEmployee">
            <div>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1">
                  <span slot="tab">
                    <a-icon type="deployment-unit"/>
                    {{$t('Integraciones Disponibles')}}
                  </span>
                  <a-card v-if="!$userIsInrol('Query')">
                    <action-group group="EMPLOYEE_INTEGRACIONES"
                                  :params="{id_emp:empleadoseleccionado}"></action-group>
                  </a-card>
                </a-tab-pane>
              </a-tabs>
            </div>
          </a-col>
        </a-row>
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import JsUtils from '@/util/JsUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    components: { },
    mounted () {
      this.httpClient = new HttpUtil()
      this.infoBasicEmployee = {
        'nombre': this.$store.state.userInfo.name,
        'identificacion': this.$store.state.userInfo.id_person
      }
      this.loadProfileData()
    },
    data () {
      return {
        initial_date: null,
        proceso_disciplinario_hoja_vida: this.$getConfigValue('PROCESO_DISCIPLINARIO_HOJA_VIDA', 'NO') === 'SI',
        doc_vinculacion_hoja_vida: this.$getConfigValue('DOCUMENTOS_VINCULACION_HOJA_VIDA', 'NO') === 'SI',
        doc_desvinculacion_hoja_vida: this.$getConfigValue('DOCUMENTOS_DESVINCULACION_HOJA_VIDA', 'NO') === 'SI',
        doc_contrato_hoja_vida: this.$getConfigValue('DOCUMENTOS_CONTRATO_HOJA_VIDA', 'NO') === 'SI',
        persona: {},
        rol: this.$userIsInrol('Hojavida') || this.$userIsInrol('Management'),
        identificacion: null,
        employeecv: [],
        colConfig: {
          sm: 24,
          md: 24
        },
        colSpan: {
          sm: 24,
          md: 12
        },
        tbConfig: {
          scroll: {x: 'max-content', y: 240},
          bordered: true,
          pagination: {
            pageSize: 5,
            showSizeChanger: true,
            pageSizeOptions: ['5', '10', '20', '30', '40'],
            showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
          }
        },
        isVisibleEmployee: false,
        empleadoseleccionado: '',
        tpay: '',
        selectedRowKeys: [],
        isVisibleDatosPersonales: false,
        infoBasicEmployee: {},
        isPoliticsVisible: false,
        loadingParent: false,
        loading: false,
        menuActivo: 'INFORMACIONLABORAL',
        menu: {
          actualizacionLaboral: 'ACTUALIZACIONLABORAL',
          datosPersonales: 'DATOSPERSONALES',
          informacionlaboral: 'INFORMACIONLABORAL',
          salario: 'SALARIO',
          beneficiosflexibles: 'BENEFICIOSFLEXIBLES',
          seguridadsocial: 'SEGURIDADSOCIAL',
          controlpago: 'CONTROLPAGO',
          retencionenfuente: 'RETENCIONENFUENTE',
          centrocostos: 'CENTRODECOSTOS',
          bancos: 'BANCOS',
          atributos: 'ATRIBUTOS',
          sanciones: 'SANCIONES',
          docVinculacion: 'DOCUMENTOS_VINCULACION',
          docDesvinculacion: 'DOCUMENTOS_DESVINCULACION',
          docContrato: 'DOCUMENTOS_CONTRATO',
          integraciones: 'INTEGRACIONES'
        },
        searchText: '',
        searchInput: null,
        searchedColumn: '',
        pagination: {
          pageSize: 5,
          showSizeChanger: true,
          pageSizeOptions: ['5', '10', '20', '30', '40'],
          showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
        },
        columns: [
          {
            title: 'ID empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            width: 200,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Nombre completo',
            dataIndex: 'nombrecompleto',
            key: 'nombrecompleto',
            width: 300,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.nombrecompleto
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Compañía',
            dataIndex: 'company',
            key: 'company',
            width: 200,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.address
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Fecha inicio del contrato',
            dataIndex: 'fecha_inicio',
            key: 'fecha_inicio',
            width: 230,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.fecha_inicio
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Fecha fin del contrato',
            dataIndex: 'fecha_fin',
            key: 'fecha_fin',
            width: 220,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.fecha_fin
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          },
          {
            title: 'Estado',
            dataIndex: 'estado',
            width: 150,
            key: 'estado',
            fixed: 'right',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.estado.length - b.estado.length,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'estado'
            },
            onFilter: (value, record) =>
              record.estado
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          }
        ]
      }
    },
    methods: {
      crearContrato () {
        this.loadProfileData()
      },
      personaCreada (person) {
        this.identificacion = person.identificacion
      },
      searchPersonChange (action) {
        if (JsUtils.isEmpty(action)) {
          this.isVisibleDatosPersonales = false
          this.isVisibleEmployee = false
          this.employeecv = []
          this.persona = []
        } else {
          this.isVisibleDatosPersonales = true
        }
      },
      handleSearch (selectedKeys, confirm, dataIndex) {
        confirm()
        this.searchText = selectedKeys[0]
        this.searchedColumn = dataIndex
      },
      handleReset (clearFilters) {
        clearFilters()
        this.searchText = ''
      },
      seleccionarMenu (e) {
        this.menuActivo = e.key
      },
      loadProfileData () {
        this.loading = true
        this.loadingParent = true
        this.httpClient.getInstance().get('employee/consultar_empleado/' + this.infoBasicEmployee.identificacion)
          .then(response => {
            this.employeecv = response.data.employeecv
            this.persona = response.data.persona
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible consultar los datos')
          })
          .then(() => {
            this.empleadoseleccionado = null
            this.selectedRowKeys = []
            this.loading = false
            this.loadingParent = false
          })
      }
    },
    computed: {
      rowSelection () {
        return {
          type: 'radio',
          selectedRowKeys: this.selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            this.initial_date = selectedRows[0].initial_date
            this.empleadoseleccionado = selectedRows[0].id_emp
            this.tpay = selectedRows[0].tpay
            this.selectedRowKeys = selectedRowKeys

            if (!JsUtils.isEmpty(this.empleadoseleccionado)) {
              this.isVisibleEmployee = true
            } else {
              this.isVisibleEmployee = false
            }
          }
        }
      },
      puedeCrear () {
        return this.rol
      },
      tamanoimg () {
        return this.rol ? 105 : 65
      }
    },
    watch: {
      infoBasicEmployee () {
        if (this.infoBasicEmployee && !JsUtils.isEmpty(this.infoBasicEmployee.identificacion)) {
          this.loadProfileData()
        }
      }
    }
  }
</script>
<style>
  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0;
  }

  /*.ant-table td { white-space: nowrap; }*/
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/EmployeeNavigation.vue